import { render, staticRenderFns } from "./FormWithMitigation.vue?vue&type=template&id=364161d0"
import script from "./FormWithMitigation.vue?vue&type=script&lang=js"
export * from "./FormWithMitigation.vue?vue&type=script&lang=js"
import style0 from "./FormWithMitigation.vue?vue&type=style&index=0&id=364161d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports